
/**
 * @fileoverview The file mananage dT Theme cookie based wishList 
 * dT_General.js, axios, vue libs are dependencies. 
 * @package
 */
class dT_WhistList {
    static sessionLists = new Map();
    static storageUnavailable = false;

    constructor() {
        this.wishListData = [];

        this.LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
        this.LOCAL_STORAGE_DELIMITER = ',';
    }

    async setupGrid(listType) {
        const handles = [...new Set(this.getWishlist())];
        const results = await Promise.allSettled(handles.map(async (handle) => {
            if (!dT_WhistList.validHandle(handle)) throw new Error('Invalid saved product');
            const text = await this.getProductResponse('/products/' + encodeURIComponent(handle) + '?view=json');
            return this.parseProductRecord(text, handle);
        }));
        this.failedHandles = handles.filter((handle, index) => results[index].status === 'rejected');
        this.wishListData = results.filter((result) => result.status === 'fulfilled').map((result) => result.value);
        return this.wishListData;
    }

    static validHandle(handle) {
        return typeof handle === 'string' && /^[a-z0-9][a-z0-9-]*$/i.test(handle);
    }

    parseProductRecord(text, expectedHandle) {
        const fields = ['id', 'product_title', 'product_handle', 'product_image', 'vendor', 'type', 'money_price',
            'price_min', 'price_max', 'available', 'price_varies', 'variant_id', 'variant_title', 'sku'];
        const raw = text.trim();
        let parsed;
        if (raw.startsWith('{') || raw.startsWith('[')) {
            parsed = JSON.parse(raw);
        } else {
            // Accept the previous 14-field response while the two files are deployed together.
            const values = raw.split('~~');
            if (values.length !== fields.length) throw new Error('Invalid product response');
            parsed = Object.fromEntries(fields.map((field, index) => [field, values[index]]));
        }
        if (!parsed || Array.isArray(parsed) || typeof parsed !== 'object' ||
            !dT_WhistList.validHandle(parsed.product_handle) || parsed.product_handle !== expectedHandle ||
            typeof parsed.product_title !== 'string' || !parsed.product_title.trim() ||
            !/^[1-9]\d*$/.test(String(parsed.id)) || !/^[1-9]\d*$/.test(String(parsed.variant_id)) ||
            typeof parsed.money_price !== 'string' ||
            !['true', 'false'].includes(String(parsed.available)) ||
            !['true', 'false'].includes(String(parsed.price_varies)) ||
            !/^\d+$/.test(String(parsed.price_min)) || !/^\d+$/.test(String(parsed.price_max)) ||
            !['product_image', 'vendor', 'type', 'variant_title', 'sku'].every((field) => typeof parsed[field] === 'string') ||
            !['id', 'variant_id'].every((field) => typeof parsed[field] !== 'number' || Number.isSafeInteger(parsed[field])) ||
            !fields.every((field) => ['string', 'number', 'boolean'].includes(typeof parsed[field]))) {
            throw new Error('Invalid product response');
        }
        const record = Object.fromEntries(fields.map((field) => [field, String(parsed[field])]));
        record.product_url = '/products/' + encodeURIComponent(record.product_handle);
        if (record.product_image) {
            const imageUrl = new URL(record.product_image, window.location.origin);
            if (!['http:', 'https:'].includes(imageUrl.protocol)) throw new Error('Invalid product image');
        }
        record.quantity = '1';
        return record;
    }

    getWishListRecords()
    {
        return this.wishListData;
    }

    getProductResponse(url) {
            
      var responseResult = fetch(url).then((response) => {
        if (!response.ok) throw new Error('Product could not be loaded');
        return response.text();
      });
     
      return responseResult;
      
    }

    getTotalCount() {
		return this.getWishlist().length;
    }
  
    getWishlist() {
        const key = this.LOCAL_STORAGE_WISHLIST_KEY;
        if (!dT_WhistList.storageUnavailable) {
          try {
            const value = localStorage.getItem(key);
            const list = value ? value.split(this.LOCAL_STORAGE_DELIMITER) : [];
            dT_WhistList.sessionLists.set(key, list);
          } catch {
            dT_WhistList.storageUnavailable = true;
          }
        }
        return [...(dT_WhistList.sessionLists.get(key) || [])];
    }

    setWishlist(array) {
        var wishlist = array.join(this.LOCAL_STORAGE_DELIMITER);
        dT_WhistList.sessionLists.set(this.LOCAL_STORAGE_WISHLIST_KEY, [...array]);
        if (!dT_WhistList.storageUnavailable) {
          try {
            if (array.length) localStorage.setItem(this.LOCAL_STORAGE_WISHLIST_KEY, wishlist);
            else localStorage.removeItem(this.LOCAL_STORAGE_WISHLIST_KEY);
          } catch {
            dT_WhistList.storageUnavailable = true;
          }
        }
        return wishlist;
    }

    updateWishlist(handle) {
        var wishlist = this.getWishlist();
        var indexInWishlist = wishlist.indexOf(handle);
        if (indexInWishlist === -1) wishlist.push(handle);
        else wishlist.splice(indexInWishlist, 1);
        return this.setWishlist(wishlist);
    }

    removeWhishlist(handle) {
        var wishlist = this.getWishlist();

        wishlist = this.remove(wishlist, handle);

        return this.setWishlist(wishlist);  
    }

    resetWishlist() {
        return this.setWishlist([]);
    }

    announceSessionFallback(control) {
      if (!dT_WhistList.storageUnavailable) return;
      let status = control.querySelector('[data-nova-storage-status]');
      if (!status) {
        status = document.createElement('span');
        status.className = 'visually-hidden';
        status.setAttribute('role', 'status');
        status.setAttribute('data-nova-storage-status', '');
        control.appendChild(status);
      }
      status.textContent = 'Saved on this page. Your browser could not save this list for later.';
    }

    isAddedIntoList(handle) {
        var wishlist = this.getWishlist();  
        
        return wishlist.includes(handle);
    }

    remove(arr) {
        var what, a = arguments, L = a.length, ax;
        while (L > 1 && arr.length) {
            what = a[--L];
            while ((ax= arr.indexOf(what)) !== -1) {
                arr.splice(ax, 1);
            }
        }
        return arr;
    };
}


async function getDTProduct(url) {
    
 
    try {
      let res = await fetch(url);

      return res.text().then(function (text) {      
        return text;
      });

        
    } catch (error) {
        console.log(error);
    }
}

class dTXWhishList extends HTMLElement {
    constructor() {
      super();
      this.dTWhistList = new dT_WhistList();
      this.addWishList = this.querySelector('.add-wishlist');
      if (!this.addWishList) return;
      this.productHandle = this.addWishList.getAttribute('data-product_handle');
      this.addLabel = this.addWishList.dataset.addLabel || window.DT_THEME?.strings?.addToWishList || 'Add to wishlist';
      this.viewLabel = this.addWishList.dataset.viewLabel || window.DT_THEME?.strings?.viewMyWishList || 'View wishlist';
      const originalLabel = this.addWishList.getAttribute('aria-label') || '';
      this.productTitle = this.addWishList.dataset.productTitle || (originalLabel.startsWith(this.addLabel + ': ') ? originalLabel.slice(this.addLabel.length + 2) : '');
      this.wishlistUrl = (window.Shopify?.routes?.root || '/') + 'collections/all?view=wishlist';
      this.debouncedOnSubmit = debounce((event) => this.onSubmitHandler(event), 500);
      this.addWishList.addEventListener('click', (event) => {
        event.preventDefault();
        if (!this.addWishList.classList.contains('adding')) this.debouncedOnSubmit(event);
      });
      if (this.addWishList.tagName !== 'BUTTON') {
        this.addWishList.setAttribute('role', 'button');
        this.addWishList.addEventListener('keydown', (event) => {
          if (event.key !== ' ' && event.key !== 'Spacebar') return;
          event.preventDefault();
          if (!event.repeat) this.addWishList.click();
        });
      }
      this.initLoad();
    }

    viewWishlist() {
      window.location.href = this.wishlistUrl;
    }

    onSubmitHandler(event) {
      event.preventDefault();
      if (this.addWishList.classList.contains('adding')) return;
      if (this.dTWhistList.isAddedIntoList(this.productHandle)) {
        this.viewWishlist();
        return;
      }
      if (!dT_WhistList.validHandle(this.productHandle)) return;
      this.addWishList.classList.add('adding');
      this.addWishList.setAttribute('aria-busy', 'true');
      this.addWishList.setAttribute('aria-disabled', 'true');
      if (this.addWishList.tagName === 'BUTTON') this.addWishList.disabled = true;
      this.dTWhistList.updateWishlist(this.productHandle);
      setTimeout(() => this.postAdd(), 1000);
    }

    postAdd() {
      this.dTWhistList.announceSessionFallback(this);
      document.querySelectorAll('.dtxc-wishlist-count').forEach((count) => {
        count.setAttribute('count', this.dTWhistList.getTotalCount());
      });
      this.addWishList.classList.remove('adding');
      this.addWishList.removeAttribute('aria-busy');
      this.addWishList.removeAttribute('aria-disabled');
      if (this.addWishList.tagName === 'BUTTON') this.addWishList.disabled = false;
      document.querySelectorAll('dtx-wishlist').forEach((control) => {
        if (control.productHandle === this.productHandle) control.initLoad();
      });
    }

    initLoad() {
      if (!this.addWishList) return;
      const saved = this.dTWhistList.isAddedIntoList(this.productHandle);
      const label = saved ? this.viewLabel : this.addLabel;
      this.addWishList.classList.toggle('added', saved);
      this.addWishList.setAttribute('aria-label', label + (this.productTitle ? ': ' + this.productTitle : ''));
      this.addWishList.removeAttribute('aria-pressed');
      const tooltip = this.closest('li')?.querySelector('tooltip');
      if (tooltip) tooltip.textContent = label;
      const icon = this.addWishList.querySelector('[data-nova-wishlist-icon]');
      if (icon) {
        icon.setAttribute('viewBox', saved ? '0 0 100 100' : '0 0 22 22');
        const shape = icon.querySelector('path');
        if (!this.outlinePath) this.outlinePath = shape.getAttribute('d');
        shape.setAttribute('d', saved ? 'M87.9,15.9c-10.6-10.6-27.5-10.6-38.1,0c-10.6-10.6-27.5-10.6-38.1,0S1.1,43.4,11.7,54l38.1,38.1L87.9,54C99,43.4,99,26.4,87.9,15.9z M81.1,30.9c-2.6,2.6-7.4,2.6-10.1,0c-2.6-2.6-2.6-7.4,0-10.1c2.6-2.6,7.4-2.6,10.1,0S83.7,28.3,81.1,30.9z' : this.outlinePath);
      }
    }
}

customElements.define('dtx-wishlist', dTXWhishList);



class dTXWhishListGrid extends HTMLElement {
    constructor() {
        super();
         
        this.gridTemplate = this.querySelector('.grid_template');

        this.dtxTable = this.querySelector(".dtx-table");
        this.dtxNoRecord = this.querySelector(".dtx-grid-empty");
      
        this.grid_type = this.getAttribute('grid_type');
      
      
        //this.initLoad();
    }

    async initLoad(focusStatus = false) {
        if (this.grid_type !== 'wishList') return;
        if (!this.listStore) {
          this.listStore = new dT_WhistList();
        }
        if (!this.loadStatus) {
          this.loadStatus = document.createElement('p');
          this.loadStatus.setAttribute('role', 'status');
          this.loadStatus.setAttribute('aria-live', 'polite');
          this.loadStatus.setAttribute('aria-atomic', 'true');
          this.loadStatus.tabIndex = -1;
          this.insertBefore(this.loadStatus, this.dtxTable);
          this.failureControls = document.createElement('div');
          this.failureControls.setAttribute('data-nova-list-failures', '');
          this.loadStatus.after(this.failureControls);
        }
        const sequence = this.loadSequence = (this.loadSequence || 0) + 1;
        this.setAttribute('aria-busy', 'true');
        this.loadStatus.textContent = 'Loading saved products…';
        this.failureControls.querySelectorAll('button').forEach((button) => { button.disabled = true; });
        try {
          const data = await this.listStore.setupGrid();
          if (sequence !== this.loadSequence) return;
          this.generateGrid(data, this.listStore.failedHandles);
        } catch {
          if (sequence !== this.loadSequence) return;
          this.generateGrid([], this.listStore.getWishlist());
        } finally {
          if (sequence === this.loadSequence) {
            this.setAttribute('aria-busy', 'false');
            this.failureControls.querySelectorAll('button').forEach((button) => { button.disabled = false; });
            if (focusStatus) this.loadStatus.focus();
          }
        }
   }
  
   generateGrid(a_records = [], failedHandles = []) {
      this.dtxTable.querySelectorAll('[data-nova-list-row]').forEach((row) => row.remove());
      a_records.forEach((record) => {
        const content = document.createElement('template');
        content.innerHTML = this.buidRow(record);
        if (!record.product_image) content.content.querySelectorAll('img').forEach((image) => image.remove());
        const removeControl = content.content.querySelector('.remove-item');
        if (removeControl) removeControl.setAttribute('aria-label', 'Remove ' + record.product_title);
        const newRow = this.dtxTable.insertRow(this.dtxTable.rows.length);
        newRow.id = 'row_' + record.id;
        newRow.setAttribute('data-nova-list-row', '');
        newRow.appendChild(content.content);
      });
      this.dtxTable.classList.toggle('dtx-grid-hide', a_records.length === 0);
      this.dtxTable.classList.toggle('dtx-grid-show', a_records.length > 0);
      const empty = a_records.length === 0 && failedHandles.length === 0;
      this.dtxNoRecord.classList.toggle('dtx-grid-hide', !empty);
      this.dtxNoRecord.classList.toggle('dtx-grid-show', empty);
      this.failureControls.replaceChildren();
      this.loadStatus.textContent = failedHandles.length
        ? a_records.length + ' saved products loaded. ' + failedHandles.length + ' could not be loaded. Retry or remove the unavailable products.'
        : (a_records.length ? a_records.length + ' saved products loaded.' : 'No saved products.');
      failedHandles.forEach((handle) => {
        const item = document.createElement('div');
        const label = document.createElement('p');
        label.textContent = 'Could not load ' + (handle || 'this saved product') + '.';
        item.appendChild(label);
        ['Retry', 'Remove'].forEach((action) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'button';
          button.textContent = action;
          button.setAttribute('aria-label', action + ' unavailable product ' + (handle || 'in this list'));
          button.addEventListener('click', () => {
            if (action === 'Remove') {
              this.listStore.removeWhishlist(handle);
              document.querySelectorAll('dtx-wish-count').forEach((counter) => {
                if (counter.getAttribute('grid_type') === this.grid_type) counter.setAttribute('count', this.listStore.getTotalCount());
              });
            }
            void this.initLoad(true);
          });
          item.appendChild(button);
        });
        this.failureControls.appendChild(item);
      });
  }
  
  buidRow(record) {
    const template = document.createElement('template');
    template.innerHTML = this.gridTemplate.innerHTML;
    const substitute = (value) => value.replace(/\{item\.(product_handle|product_url|product_image|product_title|money_price|variant_id)\}/gi,
      (match, field) => String(record[field.toLowerCase()] ?? ''));
    // Set values on inert DOM nodes so titles are literal in text and attributes.
    // Substitute once: delimiter characters, $& and placeholder-like titles stay unchanged.
    const walker = document.createTreeWalker(template.content, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) walker.currentNode.nodeValue = substitute(walker.currentNode.nodeValue);
    template.content.querySelectorAll('*').forEach((element) => {
      [...element.attributes].forEach((attribute) => {
        if (attribute.value.includes('{item.')) element.setAttribute(attribute.name, substitute(attribute.value));
      });
    });
    return template.innerHTML;
  }
  
  connectedCallback() {
    // console.log('Custom square element added to page.');
     this.initLoad();
  }
  
  
}

customElements.define('dtx-wishlist-grid', dTXWhishListGrid);



class dTXRemoveWishItem extends HTMLElement {
  
    constructor() {
        super();
         
        this.removeItem = this.querySelector('.remove-item');


        this.debouncedOnSubmit = debounce((event) => {
      	  this.removeListItem(event);
      	}, 500);

      
        this.grid_type = this.getAttribute('grid_type');
      
        this.productHandle = this.removeItem.getAttribute('data-product_handle');

        this.removeItem.addEventListener('click', this.debouncedOnSubmit.bind(this));

    }
  
    removeListItem(event)
    {
      event.preventDefault();
      if (this.grid_type !== 'wishList') return;
      
      var dTWishList = new dT_WhistList();
        

      dTWishList.removeWhishlist(this.productHandle);
      
      window.location.reload();
    }  
  
}

customElements.define('dtx-remove-wish-item', dTXRemoveWishItem);



class dTXWishCount extends HTMLElement {
  
  static get observedAttributes() {
    return ['count'];
  }  
  
  constructor() {
      super();
         
      this.gridCountBubble = this.querySelector('.grid-count-bubble');
      
      this.grid_type = this.getAttribute('grid_type');
     
      this.initLoad();
  }
  
  initLoad() {
      if (this.grid_type !== 'wishList') return;

      var dTWishList = new dT_WhistList();
      
      var totalCount = dTWishList.getTotalCount();
    
      //this.setAttribute('count', totalCount);  
    
      this.gridCountBubble.querySelector("span").innerHTML = totalCount;
    
  }
  
  attributeChangedCallback(name, oldValue, newValue) {
      this.initLoad();
  }
  
  
}

customElements.define('dtx-wish-count', dTXWishCount);



function makeTimer() {

  $('.product-deal-count').each(function() {
   
    var endTime = new Date($(this).attr('data-end-time'));		
    endTime = (Date.parse(endTime) / 1000);

    var now = new Date();
    now = (Date.parse(now) / 1000);

    var timeLeft = endTime - now;
    
    if(timeLeft > 0) {
      var days = Math.floor(timeLeft / 86400); 
      var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
      var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
      var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));

      if (hours < "10") { hours = "0" + hours; }
      if (minutes < "10") { minutes = "0" + minutes; }
      if (seconds < "10") { seconds = "0" + seconds; }

      $(this).find(".days").html(days + "<span>Days</span>");
      $(this).find(".hours").html(hours + "<span>Hrs</span>");
      $(this).find(".minutes").html(minutes + "<span>Mins</span>");
      $(this).find(".seconds").html(seconds + "<span>Secs</span>");	
      
    } else {
      $(this).find(".deal-lable").hide();
      $(this).find(".deal-clock").hide();
    }
    
  });

}

setInterval(function() { makeTimer(); }, 1000);
    


// The sidebar carousel is initialized once by dt-theme.js when it exists.

